import React from "react";
import {Elink, PrintClientPortalPdf, UpdateInventoriesUrl} from "../CommonComponents/Routes"
import axios from "axios";

// "RoundNumber" This is method is use to round up number EXAMPLE:- (1 to 1.00), (2.007 to 2.01)
// Basically this function round up the number into 2 decimal places.
const RoundNumber = (number) => {
    return (Math.round(number * 100) / 100).toFixed(2);
}

const ConvertTime = {intoDecimalFormat: (time) => {
    let finalTime = time.toString(),
        Hours = 0,
        Minutes = 0
    if (finalTime.includes(':')) {
        [Hours, Minutes] = finalTime.split(':')
    } else if (finalTime.includes('.')) {
        [Hours, Minutes] = finalTime.split('.')
    }
    Minutes = (parseInt(Minutes)/60) * 100
        if (Minutes > 100) {
            Hours = parseInt(Hours) + Minutes/100;
            Minutes = Minutes%100;
        }
        return `${Hours}.${Minutes}`},

    intoMinuteFormat: (time) => {
        let finalTime = time.toString(),
            Hours = 0,
            Minutes = 0
        if (finalTime.includes(':')) {
            [Hours, Minutes] = finalTime.split(':')
        } else if (finalTime.includes('.')) {
            [Hours, Minutes] = finalTime.split('.')
        }
        Minutes = (parseInt(Minutes)/100) * 60
        if (Minutes > 60) {
            Hours = parseInt(Hours) + Minutes/60;
            Minutes = Minutes%60;
        }
        return `${Hours}:${Minutes}`
    }
}

const OpenSignaturePadModal = (For) => {

}

export {RoundNumber, ConvertTime, OpenSignaturePadModal}